/** "LU-EY-201", "LU EY 201" and "luey201" all become "LUEY201" */
export const normalizeLicensePlate = (value: string): string => value.toUpperCase().replace(/[^A-Z0-9ÄÖÜ]/g, "");

/** letter and digit groups of a search, e.g. "hd 2023" and "HD2023" both become ["HD", "2023"] */
export const licensePlateSearchTokens = (search: string): Array<string> =>
  search.toUpperCase().match(/[A-ZÄÖÜ]+|[0-9]+/g) || [];

/**
 * True if all parts of the search appear in the plate in the same order. Parts in between may be left out,
 * so "HD 2023" finds "HD-IM-2023", while "LU-EY-201", "LU EY 201" and "LUEY201" still find "LU-EY-201".
 */
export const matchesLicensePlate = (plate: string, search: string): boolean => {
  const normalizedPlate = normalizeLicensePlate(plate);
  let position = 0;
  return licensePlateSearchTokens(search).every((token) => {
    const index = normalizedPlate.indexOf(token, position);
    if (index === -1) {
      return false;
    }
    position = index + token.length;
    return true;
  });
};
